var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 17.5,
    fill: "#584DFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 19.5,
    stroke: "#584DFF",
    strokeOpacity: 0.1,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 21.5C13 26.1945 16.8055 30 21.5 30C26.1921 29.9944 29.9944 26.1921 30 21.5C30 16.8055 26.1945 13 21.5 13C16.8055 13 13 16.8055 13 21.5ZM14.0625 21.5C14.0625 17.3924 17.3924 14.0625 21.5 14.0625C25.6058 14.0669 28.9331 17.3942 28.9375 21.5C28.9375 25.6076 25.6076 28.9375 21.5 28.9375C17.3924 28.9375 14.0625 25.6076 14.0625 21.5ZM18.8439 19.6406C18.8051 20.5177 19.1741 21.3189 19.7834 21.8602C18.5945 22.3926 17.7812 23.46 17.7812 24.6875C17.7812 24.9809 18.0191 25.2188 18.3125 25.2188C18.6059 25.2188 18.8438 24.9809 18.8438 24.6875C18.8438 23.5155 20.0353 22.5625 21.5 22.5625H21.5001C21.5229 22.5625 21.5453 22.5611 21.5672 22.5583C23.0725 22.4459 24.2234 21.1565 24.1564 19.6406C24.2244 18.1023 23.0381 16.7972 21.5001 16.7188C19.9622 16.7972 18.7759 18.1023 18.8439 19.6406ZM19.9064 19.6406C19.84 18.6894 20.55 17.8611 21.5001 17.7812C22.4503 17.8611 23.1603 18.6894 23.0939 19.6406C23.1603 20.5918 22.4503 21.4201 21.5001 21.5C20.55 21.4201 19.84 20.5918 19.9064 19.6406ZM22.718 26.1255C22.8176 26.2251 22.9528 26.2811 23.0936 26.2811C23.2345 26.2811 23.3696 26.2251 23.4692 26.1255L26.6567 22.938C26.858 22.7296 26.8552 22.3982 26.6503 22.1933C26.4453 21.9883 26.114 21.9855 25.9055 22.1868L23.0936 24.9987L22.4067 24.3118C22.1983 24.1105 21.8669 24.1133 21.662 24.3183C21.4571 24.5232 21.4542 24.8546 21.6555 25.063L22.718 26.1255Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigned);
export default __webpack_public_path__ + "static/media/assigned.6bfc6188de6e225f8d905f94eb12d3a6.svg";
export { ForwardRef as ReactComponent };